import { StyledModal } from '@app/components/modal/Modal';
import useAgentActions from '@app/hooks/agents/useAgentActions';
import type { AINumber } from '@app/services/number.types';
import type { ModalProps } from 'antd';
import { AgentForm } from './AgentForm';

export type AgentAddModalProps = ModalProps & {
    title?: string;
    data?: AINumber;
};

export const AgentAddModal = ({
    title = 'Add AI Agent',
    data,
    onOk,
    ...props
}: AgentAddModalProps) => {
    const { addAgent } = useAgentActions();

    // Reset the component if closed
    if (!props.open) {
        return null;
    }

    return (
        <StyledModal title={title} mask={{ closable: false }} footer={null} {...props}>
            <AgentForm
                id="ai-agent-add"
                data={data}
                onCancel={props.onCancel}
                loading={addAgent.isPending}
                onSubmit={(values) => {
                    const formData = {
                        ...values,
                    };
                    addAgent.mutate(formData, {
                        onSuccess: () => {
                            if (onOk) {
                                onOk(undefined as unknown as React.MouseEvent<HTMLButtonElement>);
                            }
                        },
                    });
                }}
            />
        </StyledModal>
    );
};
